import moment from "moment-timezone";
export default {
      apiBaseUrl: 'https://insta-starzz-staging.herokuapp.com/api/v1',
      // apiBaseUrl: 'https://instastarz-uat.herokuapp.com/api/v1',
      GetLanguage(data, lang, name) {
            if (data[name] === undefined) {
                  return {}
            }
            if (lang == 'en') {
                  return data[name]
            } else {
                  return data?.translations[lang][name] ? data?.translations[lang][name] : data[name]
            }
      },
      GetLanguageSameLine(data, lang) {
            if (lang == 'en') {
                  return data
            } else {
                  return (data && data.translations && data?.translations[lang]) ? data?.translations[lang] : data
            }
      },
      localUtc() {
            let time = moment.utc().tz("Asia/Kolkata").format("YYYY-MM-DDTHH:mm:ss.SSS");
            time = time + "Z";
            return time
      },
      parseDuration(duration) {
            let remain = duration
            let finalString = ''

            let days = Math.floor(remain / (1000 * 60 * 60 * 24))
            if (days > 0) finalString += `${days}d`
            remain = remain % (1000 * 60 * 60 * 24)

            let hours = Math.floor(remain / (1000 * 60 * 60))
            if (hours > 0) finalString += ` ${hours}hr`

            remain = remain % (1000 * 60 * 60)

            let minutes = Math.floor(remain / (1000 * 60))
            finalString += ` ${minutes > 0 ? (String(minutes).length == 1 ? "0" + minutes : minutes) : "00"}:`

            remain = remain % (1000 * 60)

            let seconds = Math.floor(remain / (1000))
            if (seconds > 0) finalString += ` ${(String(seconds).length == 1 ? "0" + seconds : seconds)}:`

            remain = remain % (1000)

            let milliseconds = remain
            if (milliseconds > 0) finalString += ` ${milliseconds} ms`

            return duration ? finalString : "-"
      },
      parseDurationNotification(duration) {
            let remain = duration
            let days = Math.floor(remain / (1000 * 60 * 60 * 24))
            if (days > 0) {
                  return `${days} days ago`
            }
            remain = remain % (1000 * 60 * 60 * 24)

            let hours = Math.floor(remain / (1000 * 60 * 60))
            if (hours > 0) {
                  return ` ${hours} hrs ago`
            }
            return "-"
      }
}
